export default "__VITE_ASSET__CRcY2Sup__"